export function getFileExtension(_a) {
    var src = _a.src, _b = _a.defaultExtension, defaultExtension = _b === void 0 ? 'jpg' : _b;
    var extensionAtTheEndOfString = /\.([0-9a-z]{1,5})$/;
    var match = src.match(extensionAtTheEndOfString);
    return match ? match[1] : defaultExtension;
}
//# sourceMappingURL=get-file-extension.js.map